import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  flex-flow: row wrap;
  padding: 0 ${(props) => props.theme.spacing.columnGutter};
`;

export default Row;
